const formatNumber = (value) => (Number.isFinite(Number(value)) ? Number(value).toLocaleString("en-IN") : "");

const bookingAdvanceAnswer = (pricing) => {
  const value = pricing.bookingAdvanceRequired;
  if (typeof value === "string" && /\d+\s*%/.test(value)) {
    return `An advance of ${value.match(/\d+\s*%/)[0].replace(/\s+/g, "")} is required to reserve your date.`;
  }

  return value
    ? "An advance payment is required to reserve your date."
    : "Advance payment details are shared once availability is confirmed with the venue.";
};

export const buildBanquetFaqs = (banquet = {}) => {
  const capacity = banquet.capacityDetails || {};
  const parkingDetails = banquet.parkingDetails || {};
  const food = banquet.foodCatering || {};
  const decor = banquet.decorationServices || {};
  const alcohol = banquet.alcoholPolicy && typeof banquet.alcoholPolicy === "object" ? banquet.alcoholPolicy : {};
  const pricing = banquet.pricingDetails || {};

  const parkingAvailable = typeof capacity.parkingAvailable === "boolean" ? capacity.parkingAvailable : banquet.parkingAvailable;
  const parkingCapacity = parkingDetails.totalParkingCapacity || capacity.parkingCapacity || banquet.parkingCapacity;
  const valetAvailable = Boolean(banquet.valetParking) || Boolean(parkingDetails.valetParking);

  const parkingAnswer =
    parkingAvailable === true
      ? `Yes, parking is available${parkingCapacity ? ` for approx. ${formatNumber(parkingCapacity)} vehicles` : ""}${valetAvailable ? ", including valet parking" : ""}.`
      : parkingAvailable === false
        ? "No dedicated parking is available at this venue. Please ask the venue team about nearby parking options."
        : "Parking details will be confirmed by the venue on enquiry.";

  const alcoholAllowed = typeof alcohol.alcoholAllowed === "boolean" ? alcohol.alcoholAllowed : banquet.liquorAllowed;
  const alcoholAnswer =
    alcoholAllowed === true
      ? `Yes, alcohol is allowed at this venue.${alcohol.outsideAlcoholAllowed ? " Outside alcohol is permitted." : alcohol.inhouseAlcoholAvailable ? " In-house alcohol service is available." : ""}${alcohol.corkageChargesApplicable ? ` Corkage charges may apply${alcohol.corkageCharges ? ` (${alcohol.corkageCharges})` : ""}.` : ""}`
      : alcoholAllowed === false
        ? "No, alcohol is not allowed at this venue."
        : "Alcohol policy will be confirmed by the venue on enquiry.";

  const outsideCateringAllowed = typeof food.outsideCateringAllowed === "boolean" ? food.outsideCateringAllowed : undefined;
  const cateringPolicyText = String(banquet.cateringPolicy || "").toLowerCase();
  const cateringAnswer =
    outsideCateringAllowed === true || cateringPolicyText.includes("outside catering allowed")
      ? "Yes, outside catering is allowed at this venue."
      : outsideCateringAllowed === false || cateringPolicyText.includes("in-house catering only")
        ? "No, only in-house catering is available at this venue."
        : "Catering policy will be confirmed by the venue on enquiry.";

  const decorPolicyText = String(banquet.decorPolicy || "").toLowerCase();
  const decorAnswer = decor.outsideDecoratorAllowed || decorPolicyText.includes("outside decor allowed")
    ? "Yes, outside decorators are allowed. DecorZoom can also handle your decoration end-to-end."
    : "This venue prefers in-house decoration, and DecorZoom can plan and set up your theme here.";

  const cancellationAnswer = banquet.cancellationPolicy
    ? banquet.cancellationPolicy
    : "Cancellation and rescheduling terms are confirmed by the venue team before your booking is finalised.";

  return [
    { q: "Is parking available at this venue?", a: parkingAnswer },
    { q: "Is alcohol allowed at this venue?", a: alcoholAnswer },
    { q: "Can I bring outside catering or decoration?", a: `${cateringAnswer} ${decorAnswer}` },
    { q: "How much advance payment is required to book?", a: bookingAdvanceAnswer(pricing) },
    { q: "What is the cancellation policy?", a: cancellationAnswer },
  ];
};
